// API Service per gestione Agency
import { AxiosResponse } from "axios";
import axios from "axios";

const BASE_URL = window.location.hostname === "localhost" 
  ? "http://localhost:3000" 
  : (process.env.REACT_APP_API_URL || "");

// Configurazione di axios
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export interface Agency {
  id: string;
  nome: string;
  descrizione: string;
  dataIscrizione: string;
  createdAt: string;
  updatedAt: string;
  stats?: {
    contentCount: number;
    videoCount: number;
  };
}

export interface AgencyListResponse {
  success: boolean;
  data: Agency[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  error?: string;
}

export interface AgencyResponse {
  success: boolean;
  data?: Agency;
  message?: string;
  error?: string;
}

export interface CreateAgencyData {
  nome: string;
  descrizione: string;
}

export interface UpdateAgencyData {
  nome?: string;
  descrizione?: string;
  metadata?: any;
}

/**
 * Recupera la lista delle agency con paginazione
 */
export const getAgencies = async (
  page = 1,
  limit = 10,
  sortBy = "nome",
  sortOrder = "asc"
): Promise<AgencyListResponse> => {
  try {
    const response: AxiosResponse<AgencyListResponse> = await api.get(
      `/api/agencies?page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Errore nel recupero delle agency:", error);
    throw new Error(
      error.response?.data?.error || "Errore nel recupero delle agency"
    );
  }
};

/**
 * Crea una nuova agency
 */
export const createAgency = async (
  agencyData: CreateAgencyData
): Promise<AgencyResponse> => {
  try {
    const response: AxiosResponse<AgencyResponse> = await api.post(
      "/api/agencies",
      agencyData
    );
    return response.data;
  } catch (error: any) {
    console.error("Errore nella creazione dell'agency:", error);
    throw new Error(
      error.response?.data?.error || "Errore nella creazione dell'agency"
    );
  }
};

/**
 * Recupera i dettagli di una agency specifica
 */
export const getAgencyById = async (id: string): Promise<AgencyResponse> => {
  try {
    const response: AxiosResponse<AgencyResponse> = await api.get(
      `/api/agencies/${id}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Errore nel recupero dettagli agency:", error);
    throw new Error(
      error.response?.data?.error || "Errore nel recupero dei dettagli"
    );
  }
};

/**
 * Aggiorna una agency esistente
 */
export const updateAgency = async (
  id: string,
  agencyData: UpdateAgencyData
): Promise<AgencyResponse> => {
  try {
    const response: AxiosResponse<AgencyResponse> = await api.put(
      `/api/agencies/${id}`,
      agencyData
    );
    return response.data;
  } catch (error: any) {
    console.error("Errore nell'aggiornamento dell'agency:", error);
    throw new Error(
      error.response?.data?.error || "Errore nell'aggiornamento dell'agency"
    );
  }
};

/**
 * Elimina una agency
 */
export const deleteAgency = async (id: string): Promise<AgencyResponse> => {
  try {
    const response: AxiosResponse<AgencyResponse> = await api.delete(
      `/api/agencies/${id}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Errore nell'eliminazione dell'agency:", error);
    throw new Error(
      error.response?.data?.error || "Errore nell'eliminazione dell'agency"
    );
  }
};

/**
 * Ottiene una lista semplice di agency per select/dropdown
 */
export const getAgenciesForSelect = async (): Promise<{ value: string; label: string }[]> => {
  try {
    const response = await getAgencies(1, 100, "nome", "asc");
    return response.data.map(agency => ({
      value: agency.nome,
      label: agency.nome
    }));
  } catch (error) {
    console.error("Errore nel recupero agency per select:", error);
    return [];
  }
};

export default {
  getAgencies,
  createAgency,
  getAgencyById,
  updateAgency,
  deleteAgency,
  getAgenciesForSelect,
};